import { render, staticRenderFns } from "./NovaDemanda.vue?vue&type=template&id=45b580ea&"
import script from "./NovaDemanda.vue?vue&type=script&lang=js&"
export * from "./NovaDemanda.vue?vue&type=script&lang=js&"
import style0 from "./NovaDemanda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports